import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Select, Spin } from "antd";
import type { AppDispatch } from "../../../../core/data/redux/store";
import { fetchRoundTemplates } from "../../../../core/data/redux/recruitment/thunks";
import type { RoundTemplate } from "../../../../core/data/redux/recruitment/types";

interface RoundTemplateSelectorProps {
  onSelectTemplate: (template: RoundTemplate) => void;
}

const RoundTemplateSelector: React.FC<RoundTemplateSelectorProps> = ({ onSelectTemplate }) => {
  const dispatch = useDispatch<AppDispatch>();
  const templates: RoundTemplate[] = useSelector((state: any) => state.recruitment.roundTemplates);
  const loading = useSelector((state: any) => state.recruitment.roundTemplatesLoading);
  const [selectedId, setSelectedId] = useState<number | undefined>(undefined);

  useEffect(() => {
    dispatch(fetchRoundTemplates());
  }, [dispatch]);

  const handleChange = (value: number) => {
    setSelectedId(value);
    const template = templates.find((t) => t.id === value);
    if (template) {
      onSelectTemplate(template);
    }
  };

  return (
    <div className="mb-4 p-3 border rounded d-flex align-items-center gap-3 bg-light">
      <div style={{ flexShrink: 0 }}>
        <i className="ti ti-template text-primary" style={{ fontSize: 24 }} />
      </div>
      <div style={{ flexGrow: 1 }}>
        <h6 className="mb-1">Start from a Template</h6>
        <p className="text-muted mb-0" style={{ fontSize: 13 }}>
          Load a pre-configured multi-stage interview pipeline to save time.
        </p>
      </div>
      <div style={{ width: 280 }}>
        <Select
          showSearch
          allowClear
          placeholder="Select a pipeline template..."
          loading={loading}
          value={selectedId}
          onChange={handleChange}
          style={{ width: "100%" }}
          options={templates.map((t) => ({
            value: t.id,
            label: (
              <div className="d-flex justify-content-between align-items-center">
                <span>{t.template_name}</span>
                <span className="badge bg-light text-muted" style={{ fontSize: 10 }}>
                  {t.stages.length} stages
                </span>
              </div>
            ),
          }))}
          notFoundContent={loading ? <Spin size="small" /> : null}
        />
      </div>
    </div>
  );
};

export default RoundTemplateSelector;
